import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-incident-list"
}
const _hoisted_2 = {
  key: 0,
  class: "as-incident-list__head"
}
const _hoisted_3 = { class: "as-player" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "as-player__detail" }
const _hoisted_6 = { class: "as-player__point" }
const _hoisted_7 = { class: "as-num" }
const _hoisted_8 = { class: "as-player__name" }
const _hoisted_9 = { class: "as-player as-player__away" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "as-player__detail" }
const _hoisted_12 = { class: "as-player__point" }
const _hoisted_13 = { class: "as-num" }
const _hoisted_14 = { class: "as-player__name" }
const _hoisted_15 = { class: "as-incident-list__list" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "as-incident-list__row"
}
const _hoisted_18 = { class: "as-time" }
const _hoisted_19 = { class: "as-right" }
const _hoisted_20 = {
  key: 1,
  class: "as-incident-list__row"
}
const _hoisted_21 = { class: "as-left" }
const _hoisted_22 = { class: "as-time" }

import { ref, computed } from "vue";
import { mapPlayer } from "~src/helpers/basketball";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import type { IMatch } from "~src/interfaces/basketball";
import IncidentPlayer from "~src/components/incidents/basketball/IncidentPlayer.vue";
import NoData from "~src/components/NoData.vue";


const __default__ = {};

interface IProps {
  isPopup: boolean;
  detailShooting: {
    shootingPoints: IRow;
    match: IMatch;
  };
}

interface IRow {
  data: {
    teamGoal: number;
    remaining_time: number;
    point: number;
    [key: string]: any;
  }[];
  match_status: number;
}

interface IData {
  title: string;
  home: number;
  away: number;
  home_player_id: string | null;
  home_player_name: string | null;
  away_player_id: string | null;
  away_player_name: string | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsList',
  props: {
    isPopup: { type: Boolean, default: true },
    detailShooting: {}
  },
  setup(__props: any) {

const props = __props;

const rows: any = computed(() => {
  const rs = props?.detailShooting?.shootingPoints;
  if (!rs) return [];
  const { home_scores, away_scores } = props?.detailShooting?.match;
  const data: any[] = [];
  rs.map((item: any) => {
    const t = item.data.filter((i: any) => {
      return i.homeScore > 0 || i.awayScore > 0;
    });

    if (item.match_status !== 10) {
      let indexCurrentScore = 0;
      if (item.match_status === 8) {
        indexCurrentScore = 3;
      } else if (item.match_status === 6) {
        indexCurrentScore = 2;
      } else if (item.match_status === 4) {
        indexCurrentScore = 1;
      } else if (item.match_status === 2) {
        indexCurrentScore = -1;
      }
      data.push({
        data: t,
        match_status: item.match_status,
        indexCurrentScore,
      });
    }
  });

  return data;
});
const calculateTotalScore = (scores: number[], index: number) => {
  let total = 0;
  for (let i = 0; i <= index; i++) {
    total += scores[i];
  }
  return total;
};
const collapses = computed(() => {
  if (!props?.detailShooting?.shootingPoints) return [];
  const data: any[] = [];
  let jsonData = props?.detailShooting?.shootingPoints;
  const includeStatusEnd = jsonData.find(
    (item: any) => item.match_status === 10
  );
  jsonData = jsonData.filter((item: any) => item.match_status != 10);

  jsonData.map((item: any, index: any) => {
    let title = "";
    let value = 0;
    const { home_scores, away_scores } = props?.detailShooting?.match;
    if (item.match_status === 8 && !includeStatusEnd) {
      title = `H4 ${calculateTotalScore(
        home_scores,
        3
      )} - ${calculateTotalScore(away_scores, 3)}`;
      if (item?.data.length === 1) {
        title = `H4 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 8 && includeStatusEnd) {
      title = `FT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `H4 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 9 && includeStatusEnd) {
      title = `FT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `OT 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 9 && !includeStatusEnd) {
      title = `OT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `OT 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 6) {
      title = `H3 ${calculateTotalScore(
        home_scores,
        2
      )} - ${calculateTotalScore(away_scores, 2)}`;
      if (item?.data.length === 1) {
        title = `H3 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 4) {
      title = `H2 ${calculateTotalScore(
        home_scores,
        1
      )} - ${calculateTotalScore(away_scores, 1)}`;
      if (item?.data.length === 1) {
        title = `H2 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 2) {
      title = `H1 ${calculateTotalScore(
        home_scores,
        0
      )} - ${calculateTotalScore(away_scores, 0)}`;
      if (item?.data.length === 1) {
        title = `H1 0 - 0`;
      }
      value = index;
    }
    // value = index;
    if (title) {
      data.push({
        title,
        value,
      });
    }
  });
  return data;
});

let activeCollapse: any = ref(collapses?.value[0]?.value) || 0;

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};

const convertTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds}`;
};

const getParcent = (homeVal: number, awayVal: number) => {
  const total: number = homeVal + awayVal;

  const rsHome = ((homeVal / total) * 100).toFixed();
  const rsAway = ((awayVal / total) * 100).toFixed();

  return {
    home: rsHome,
    away: rsAway,
  };
};

const datas = computed(() => {
  const items: IData[] = [
    {
      title: "Điểm",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
  ];

  if (props?.detailShooting?.lineups?.players) {
    for (const player of props?.detailShooting?.lineups.players.home) {
      if (player.data.score > items[0].home) {
        items[0].home = player.data.score;
        items[0].home_player_id = player.id;
        items[0].home_player_name = player.name;
      }
    }
    for (const player of props?.detailShooting?.lineups.players.away) {
      if (player.data.score > items[0].away) {
        items[0].away = player.data.score;
        items[0].away_player_id = player.id;
        items[0].away_player_name = player.name;
      }
    }
  }

  return items;
});

return (_ctx: any,_cache: any) => {
  return (rows.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (datas.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.getImgUrlBySport('player', datas.value[0]?.home_player_id || 'default'),
                  class: "as-player__logo",
                  alt: "Unknown Player Name"
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(datas.value[0]?.home), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "as-txt" }, "PTS", -1))
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(datas.value[0]?.home_player_name), 1)
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-head-content" }, "Kiếm nhiều điểm nhất", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.getImgUrlBySport('player', datas.value[0]?.away_player_id || 'default'),
                  class: "as-player__logo",
                  alt: "Unknow"
                }, null, 8, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(datas.value[0]?.away), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "as-txt" }, "PTS", -1))
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(datas.value[0]?.away_player_name), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "as-incident-list__item"
            }, [
              _createElementVNode("h3", {
                onClick: ($event: any) => (changeActiveCollapse(index)),
                class: _normalizeClass({
            'as-active': _unref(activeCollapse) === index,
          })
              }, [
                _createElementVNode("span", null, _toDisplayString(collapses.value.find((collapse) => collapse.value == index)?.title), 1),
                _createVNode(ArrowDown, { fill: "#4CF446" })
              ], 10, _hoisted_16),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.data, (data) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  (data.teamGoal === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-left" }, null, -1)),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(convertTime(data.remaining_time)), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(IncidentPlayer, {
                            player: data,
                            playerName: 
                  _unref(mapPlayer)(data[1], props?.detailShooting?.listPlayer)?.name ||
                  ''
                ,
                            point: data.point,
                            type: "away",
                            pointHomeMatch: props?.detailShooting?.match.away_scores,
                            pointAwayMatch: props?.detailShooting?.match.home_scores,
                            indexCurrentScore: row.indexCurrentScore
                          }, null, 8, ["player", "playerName", "point", "pointHomeMatch", "pointAwayMatch", "indexCurrentScore"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(IncidentPlayer, {
                            player: data,
                            playerName: 
                  _unref(mapPlayer)(data[1], props?.detailShooting?.listPlayer)?.name ||
                  ''
                ,
                            point: data.point,
                            type: "home",
                            pointHomeMatch: props?.detailShooting?.match.away_scores,
                            pointAwayMatch: props?.detailShooting?.match.home_scores,
                            indexCurrentScore: row.indexCurrentScore
                          }, null, 8, ["player", "playerName", "point", "pointHomeMatch", "pointAwayMatch", "indexCurrentScore"])
                        ]),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(convertTime(data.remaining_time)), 1),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-right" }, null, -1))
                      ]))
                ], 512)), [
                  [_vShow, _unref(activeCollapse) === index]
                ])
              }), 256))
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})